/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapsuleIo } from './pages'

type TIdToPageMapStylioCapsuleIo = Record<PageIdStylioCapsuleIo, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_CAPSULE_IO: TIdToPageMapStylioCapsuleIo = {
  [PageIdStylioCapsuleIo.AGE_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/AgeQuestion'
      ).then((m) => ({
        default: m.AgeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCapsuleIo.URGE_CAPSULE_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_io/pages/urge/UrgePage').then(
        (m) => ({
          default: m.UrgePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/urge/UrgePage'),
  },
  [PageIdStylioCapsuleIo.HAIR_COLOR_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/HairColorQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.EYES_COLOR_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/EyesColorQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.JEWELRY_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/JewelryQuestion'
      ).then((m) => ({
        default: m.JewelryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioCapsuleIo.BODY_SHAPE_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/BodyShapeQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.OUTFIT_STRUGGLES_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/OutfitStruggles/OutfitStruggles'
      ).then((m) => ({
        default: m.OutfitStruggles,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/OutfitStruggles/OutfitStruggles'
      ),
  },
  [PageIdStylioCapsuleIo.STYLIO_TO_HELP_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/StylioToHelp'
      ).then((m) => ({
        default: m.StylioToHelp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/questions/StylioToHelp'),
  },
  [PageIdStylioCapsuleIo.TALL_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/TallQuestion'
      ).then((m) => ({
        default: m.TallQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/questions/TallQuestion'),
  },
  [PageIdStylioCapsuleIo.WEIGHT_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/WeightQuestion'
      ).then((m) => ({
        default: m.WeightQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/questions/WeightQuestion'),
  },
  [PageIdStylioCapsuleIo.BODY_COMFORT_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/BodyComfort/BodyComfort'
      ).then((m) => ({
        default: m.BodyComfort,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/abtest/BodyComfort/BodyComfort'),
  },
  [PageIdStylioCapsuleIo.WHAT_YOU_WEAR_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/WhatYouWear/WhatYouWear'
      ).then((m) => ({
        default: m.WhatYouWear,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/abtest/WhatYouWear/WhatYouWear'),
  },
  [PageIdStylioCapsuleIo.URGE_2_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/urge/UrgePageVariant2'
      ).then((m) => ({
        default: m.UrgePageVariant2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCapsuleIo.FEEL_ABOUT_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/FeelAboutQuestion'
      ).then((m) => ({
        default: m.FeelAboutQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/FeelAboutQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.WARDROBE_USAGE_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/WardrobeUsage/WardrobeUsage'
      ).then((m) => ({
        default: m.WardrobeUsage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/WardrobeUsage/WardrobeUsage'
      ),
  },
  [PageIdStylioCapsuleIo.NOT_ALONE_CAPSULE_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_io/abtest/NotAlone/NotAlone').then(
        (m) => ({
          default: m.NotAlone,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/abtest/NotAlone/NotAlone'),
  },
  [PageIdStylioCapsuleIo.PERCENTAGE_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/PercentageQuestion'
      ).then((m) => ({
        default: m.PercentageQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/PercentageQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.SHOPPING_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/ShoppingQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.STYLE_MOST_MATTERS_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.YOUR_LOCATION_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/YourLocation/YourLocation'
      ).then((m) => ({
        default: m.YourLocation,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/YourLocation/YourLocation'
      ),
  },
  [PageIdStylioCapsuleIo.FAVORITE_COLORS_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislike'
      ).then((m) => ({
        default: m.LikeOrDislikeQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislike'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_11_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant11'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant11'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_12_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant12'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant12Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant12'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_13_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant13'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant13Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant13'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_14_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant14'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant14'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_15_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant15'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant15'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_16_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant16'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant16Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant16'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_17_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant17'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant17Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant17'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_18_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant18'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant18'
      ),
  },
  [PageIdStylioCapsuleIo.LIKE_OR_DISLIKE_19_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant19'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/likeOrDislike/LikeOrDislikeVariant19'
      ),
  },
  [PageIdStylioCapsuleIo.SEE_YOURSELF_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/SeeYourself/SeeYourself'
      ).then((m) => ({
        default: m.SeeYourself,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/abtest/SeeYourself/SeeYourself'),
  },
  [PageIdStylioCapsuleIo.STYLES_FEEL_LIKE_YOU_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.URGE_3_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/urge/UrgePageVariant3'
      ).then((m) => ({
        default: m.UrgePageVariant3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCapsuleIo.BRAND_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/BrandQuestion'
      ).then((m) => ({
        default: m.BrandQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/questions/BrandQuestion'),
  },
  [PageIdStylioCapsuleIo.FIND_NEW_CLOTHES_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.NOTHING_TO_WEAR_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.OLD_CLOTHES_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/OldClothesQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.COMBINE_CLOTHES_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.OPTIMIZE_BUDGET_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioCapsuleIo.URGE_4_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/urge/UrgePageVariant4'
      ).then((m) => ({
        default: m.UrgePageVariant4,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCapsuleIo.WHAT_YOU_WILL_FIND_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/WhatYouWillFind/WhatYouWillFind'
      ).then((m) => ({
        default: m.WhatYouWillFind,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/WhatYouWillFind/WhatYouWillFind'
      ),
  },
  [PageIdStylioCapsuleIo.PREPARE_FLOW_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/prepareFlow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCapsuleIo.EMAIL_CAPSULE_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_io/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsule_io/pages/email/Email'),
  },
  [PageIdStylioCapsuleIo.EMAIL_CONSENT_CAPSULE_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_io/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/email/EmailConsent'),
  },
  [PageIdStylioCapsuleIo.SUBSCRIPTIONS_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/subscriptions/SubscriptionPage'
      ).then((m) => ({
        default: m.SubscriptionPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/subscriptions/SubscriptionPage'
      ),
  },
  [PageIdStylioCapsuleIo.CANCEL_OFFER_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/cancel-offer/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCapsuleIo.AI_STYLIST_UPSELL_CAPSULE_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_io/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapsuleIo.SUB_UPSELL_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/pdf-sub-upsell/PdfSubUpsell'
      ).then((m) => ({
        default: m.PdfSubUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/pdf-sub-upsell/PdfSubUpsell'
      ),
  },
  [PageIdStylioCapsuleIo.UPSELL_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/BundleUpsell/ProportionsUpsell'
      ).then((m) => ({
        default: m.ProportionsUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/BundleUpsell/ProportionsUpsell'
      ),
  },
  [PageIdStylioCapsuleIo.FACE_UPSELL_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/BundleUpsell/FaceUpsell'
      ).then((m) => ({
        default: m.FaceUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_io/abtest/BundleUpsell/FaceUpsell'),
  },
  [PageIdStylioCapsuleIo.BUNDLE_UPSELL_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/BundleUpsell/BundleUpsell'
      ).then((m) => ({
        default: m.BundleUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/abtest/BundleUpsell/BundleUpsell'
      ),
  },
  [PageIdStylioCapsuleIo.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioCapsuleIo.DOWNLOAD_CAPSULE_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_io/pages/download-app/DownloadDefault'
      ),
  },
}
